package ui.pages

import androidx.compose.runtime.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import org.jetbrains.compose.web.attributes.*
import ui.components.organisms.MainLayout
import ui.components.organisms.DashboardContent
import ui.components.molecules.SettingsModal
import ui.components.atoms.FloatingActionButton
import ui.components.*
import presentation.state.AppState
import domain.model.*

@Composable
fun DashboardPage(
    state: AppState,
    onThemeToggle: () -> Unit,
    onSettingsClick: () -> Unit,
    onAddActionClick: () -> Unit,
    onRefresh: () -> Unit,
    onLogout: () -> Unit,
    onViewModeChange: (PRViewMode) -> Unit,
    onCloseSettings: () -> Unit,
    onRefreshOrganizations: () -> Unit,
    onCloseAddAction: () -> Unit,
    onSaveAction: (String, String, String, String) -> Unit,
    onCloseTheme: () -> Unit,
    onThemeChange: (ui.theme.ThemeMode) -> Unit
) {
    MainLayout(
        state = state,
        onThemeToggle = onThemeToggle,
        onSettingsClick = onSettingsClick,
        onAddActionClick = onAddActionClick
    ) {
        DashboardContent(
            state = state,
            onRefresh = onRefresh,
            onLogout = onLogout,
            onViewModeChange = onViewModeChange
        )
    }
    
    // Floating Action Button (GitHub Copilot)
    if (state.isAuthenticated) {
        FloatingActionButton(
            icon = "🤖",
            onClick = { 
                println("Opening Copilot chat...")
                // TODO: Integrate with GitHub Copilot Chat API
            },
            color = "#8b5cf6"
        )
    }
    
    // Modals
    if (state.showSettingsModal) {
        SettingsModal(
            isOpen = state.showSettingsModal,
            onClose = onCloseSettings,
            organizations = state.organizations,
            pendingInvitations = state.pendingInvitations,
            onLogout = onLogout,
            onRefreshOrganizations = onRefreshOrganizations
        )
    }
    
    if (state.showAddActionModal) {
        AddActionModal(
            onSave = onSaveAction,
            onCancel = onCloseAddAction
        )
    }
    
    if (state.showThemeModal) {
        ThemeToggleModal(
            currentTheme = state.currentTheme,
            onThemeChange = onThemeChange,
            onClose = onCloseTheme
        )
    }
    
    if (state.showOrganizationDiagnosis) {
        OrganizationAccessHelper(
            diagnosis = state.organizationDiagnosis,
            isLoading = state.isDiagnosingOrganizations,
            onRunDiagnosis = { /* Handle diagnosis */ },
            onReauthorize = { /* Handle reauth */ },
            onClose = { /* Handle close */ }
        )
    }
}